/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const designerAccountRouters = {
  path: '/designerAccount',
  component: Layout,
  name: 'designerAccount',
  meta: {
    title: '服务人员账号管理',
    icon: 'el-icon-files'
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/designer/list'),
      name: 'designerAccountList',
      meta: { title: '服务人员账号' }
    }
  ]
}

export default designerAccountRouters
